"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClassThrusterDirection = getClassThrusterDirection;
var _missionStateConstants = require("../constants/missionStateConstants");
var _students = require("./students");
var _lodash = require("lodash");
const MIN_UPGRADE_ACCELERATION = 0.5;
const MAX_UPGRADE_ACCELERATION = 1.25;
const MAX_MAGNITUDE = 1.15;
const UPGRADE_PER_LEVEL = (MAX_UPGRADE_ACCELERATION - MIN_UPGRADE_ACCELERATION) / _missionStateConstants.THRUSTERS_STATION.MAX_UPGRADE_LEVEL;

/**
 * getThrusterVector - get a vector describing the direction and magnitude of the thrusters based off the
 * student thrusters station
 *
 * @param  {?BothFullMissionStates} state - the fullState to get the class's thruster direction from
 * @returns {Direction} - the direction and magnitude (average in range [0, 1]) the class thrusters are pointing
 */
function getClassThrusterDirection(state) {
  if (!state) {
    return {
      angle: 0,
      magnitude: 0
    };
  }
  const activeStudentsAndOwners = (0, _students.getConnectedStudents)(state, true);
  let x = 0;
  let y = 0;
  let studentCount = 0;
  Object.keys(activeStudentsAndOwners).forEach(studentId => {
    const student = activeStudentsAndOwners[studentId];
    const studentThruster = state.stationData.thrusters.studentData[studentId];
    const studentDirection = studentThruster?.direction;
    const upgrade = studentThruster?.engine.level ?? 0;
    if (!student.isOwner || studentDirection) {
      studentCount += 1;
    }
    if (!studentDirection) {
      return;
    }
    const magnitude = (0, _lodash.clamp)(studentDirection.magnitude, 0, 1) * (MIN_UPGRADE_ACCELERATION + upgrade * UPGRADE_PER_LEVEL);
    const angle = studentDirection.angle;
    x += Math.cos(angle) * magnitude;
    y += Math.sin(angle) * magnitude;
  });
  const RadiansInCircle = 2 * Math.PI;
  return {
    magnitude: Math.min(studentCount === 0 ? 0 : Math.sqrt(x ** 2 + y ** 2) / studentCount, MAX_MAGNITUDE),
    // force angle to be between 0 and 2 pi
    angle: (Math.atan2(y, x) % RadiansInCircle + RadiansInCircle) % RadiansInCircle
  };
}